import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { forkJoin, Observable } from 'rxjs';
import { CoreService, ProleisObject } from 'proleis-rest-client';
import { RedirectService } from '../../../services/redirect.service';

@Component({
  selector: 'app-chain-details-dialog',
  templateUrl: './chain-details-dialog.component.html',
  styleUrls: ['./chain-details-dialog.component.scss'],
})
export class ChainDetailsDialogComponent implements OnInit {
  linkObjects: Observable<ProleisObject[]>;
  direction: string;

  constructor(
    public dialogRef: MatDialogRef<ChainDetailsDialogComponent>,
    private cs: CoreService,
    private rs: RedirectService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.direction = this.data.direction;

    const requests = [];
    this.data.ids
      .split(',')
      .forEach((id) => requests.push(this.cs.getObjectById<ProleisObject>(id)));

    this.linkObjects = forkJoin(requests);
  }

  redirect(id: string) {
    this.rs.redirectToInfoPanel(id);
    this.dialogRef.close(id);
  }

  cancel() {
    this.dialogRef.close();
  }
}
